module.exports = __webpack_public_path__ + "img/12.526c1f1c.png";